import {
  CreateCustomerV1Dto,
  CustomersService,
  CustomerV1Dto,
  PatchCustomerV1Dto,
} from '@/openapi';
import { eventBus } from '@/configs/eventBus';

import type { CustomerSimple } from '../customersTypes';

export function useCustomers() {
  const fetchCustomer = async (id: string) => {
    try {
      return await CustomersService.customerControllerV1FindOneV1(id);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCustomers = async () => {
    try {
      return await CustomersService.customerControllerV1FindAllV1();
    } catch (err) {
      console.log(err);
    }
  };

  const createCustomer = async (data: CreateCustomerV1Dto) => {
    try {
      await CustomersService.customerControllerV1CreateV1(data);
      eventBus.emit('create');
    } catch (err) {
      console.log(err);
    }
  };

  const linkCustomerToAddresses = async (customerId: string, addressId: string) => {
    try {
      await CustomersService.customerToAddressControllerV1LinkAddressV1(customerId, addressId);
      eventBus.emit('update');
    } catch (err) {
      console.log(err);
    }
  };

  const updateCustomer = async (id: string, data: PatchCustomerV1Dto) => {
    try {
      await CustomersService.customerControllerV1UpdatePartialV1(id, data);
      eventBus.emit('update');
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCustomer = async (ids: string) => {
    try {
      await CustomersService.customerControllerV1RemoveOneV1(ids);
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCustomers = async (ids: string[]) => {
    try {
      await CustomersService.customerControllerV1RemoveManyV1({ values: ids });
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCustomerAddress = async (customerId: string, addressId: string) => {
    try {
      await CustomersService.customerToAddressControllerV1UnlinkAddressV1(customerId, addressId);
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCustomerAddresses = async (customerId: string, addressIds: string[]) => {
    try {
      await CustomersService.customerToAddressControllerV1RemoveManyAddressesV1(customerId, {
        values: addressIds,
      });
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  return {
    fetchCustomer,
    fetchCustomers,
    createCustomer,
    linkCustomerToAddresses,
    updateCustomer,
    deleteCustomer,
    deleteCustomers,
    deleteCustomerAddress,
    deleteCustomerAddresses,
  };
}

export function useCustomersConverter() {
  const convertCustomerDtoToCustomerSimple = (data: CustomerV1Dto): CustomerSimple => {
    const { createdAt: _createdAt, modifiedAt: _modifiedAt, ...res } = data;
    return res;
  };

  const convertCustomerDtoListToCustomerSimpleList = (data: CustomerV1Dto[]): CustomerSimple[] => {
    return data.map(convertCustomerDtoToCustomerSimple);
  };

  const convertCustomerSimpleToCreateCustomerDto = (data: CustomerSimple): CreateCustomerV1Dto => {
    const {
      version: _version,
      id: _id,
      partnerBankingAccounts: _partnerBankingAccounts,
      bankingAccounts: _bankingAccounts,
      contactPersonToCustomer: _contactPersonToCustomer,
      addresses: _addresses,
      ...res
    } = data;
    return res;
  };

  const convertCustomerSimpleToUpdateCustomerDto = (data: CustomerSimple): PatchCustomerV1Dto => {
    const {
      id: _id,
      partnerBankingAccounts: _partnerBankingAccounts,
      bankingAccounts: _bankingAccounts,
      contactPersonToCustomer: _contactPersonToCustomer,
      addresses: _addresses,
      ...res
    } = data;
    return res;
  };

  return {
    convertCustomerDtoToCustomerSimple,
    convertCustomerDtoListToCustomerSimpleList,
    convertCustomerSimpleToCreateCustomerDto,
    convertCustomerSimpleToUpdateCustomerDto,
  };
}
